// extracted by mini-css-extract-plugin
export default {"wrapper":"Qq-z","response":"Rq-z","error":"Sq-z","disabled":"Tq-z","buttons":"Uq-z","feedbackQuestionSection":"Vq-z","yesNoWrapper":"Wq-z"};